import { jsx as _jsx } from "react/jsx-runtime";
export function StickyCta({ children, withTabBar: _withTabBar = false, className = '', }) {
    return (_jsx("div", { "data-testid": "sticky-cta", className: `
        fixed inset-x-0 bottom-0 z-50
        border-t border-cyan-border-faint
        ${className}
      `, style: {
            paddingTop: '12px',
            paddingLeft: '20px',
            paddingRight: '20px',
            paddingBottom: 'max(12px, env(safe-area-inset-bottom))',
            backgroundColor: 'rgba(248, 249, 251, 0.96)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
        }, children: _jsx("div", { className: "mx-auto flex w-full max-w-[430px] flex-col gap-3", children: children }) }));
}
//# sourceMappingURL=StickyCta.js.map